import { AlertIcon, FlatCheckIcon } from './icons';
import { bulkDraftMissingRequired, bulkDraftReady, getBulkCheckState } from './groupings';

function renderCheckChip(kind, val, listing) {
    const check = getBulkCheckState(listing);

    if (kind === 'photos') {
        const n = check.photos || 0;
        if (n === 0) return <span className="props-row-check pending">⬚ 0 photos</span>;
        if (check.photoSource === 'mixed') {
            return (
                <span className="props-row-check done">
                    <FlatCheckIcon /> {n} photos · AI + host
                </span>
            );
        }
        if (check.photoSource === 'ai') {
            return (
                <span className="props-row-check done">
                    <FlatCheckIcon /> {n} photos · AI-pulled
                </span>
            );
        }
        return (
            <span className="props-row-check done">
                <FlatCheckIcon /> {n} photo{n === 1 ? '' : 's'}
            </span>
        );
    }

    if (kind === 'geofence') {
        if (val) {
            return (
                <span className="props-row-check done">
                    <FlatCheckIcon /> Geofence reviewed
                </span>
            );
        }
        return (
            <span className="props-row-check missing">
                <AlertIcon size={10} />
                {' '}
                Geofence
            </span>
        );
    }

    if (kind === 'ai') {
        if (val === 0) {
            return (
                <span className="props-row-check done">
                    <FlatCheckIcon /> AI confirmed
                </span>
            );
        }
        return (
            <span className="props-row-check warn">
                ▣ {val} AI field{val === 1 ? '' : 's'} to confirm
            </span>
        );
    }

    if (kind === 'insurance') {
        if (val) {
            return (
                <span className="props-row-check done">
                    <FlatCheckIcon /> Additional Insured
                </span>
            );
        }
        return (
            <span className="props-row-check warn">
                ⬚ Additional Insured
            </span>
        );
    }

    return null;
}

export default function BulkChecklistChips({ listing }) {
    const missingReq = bulkDraftMissingRequired(listing);
    const check = getBulkCheckState(listing);
    const ready = bulkDraftReady(listing);

    return (
        <div className="props-row-checklist">
            {missingReq.length > 0 && (
                <span className="props-row-check missing">
                    <AlertIcon size={10} />
                    {' '}
                    Missing: {missingReq.join(', ')}
                </span>
            )}
            {renderCheckChip('photos', check.photos, listing)}
            {renderCheckChip('geofence', check.geofenceReviewed, listing)}
            {renderCheckChip('ai', check.aiPending, listing)}
            {renderCheckChip('insurance', check.insuranceAddressed, listing)}
            {ready && (
                <span className="props-row-check done">
                    <FlatCheckIcon /> Ready to submit
                </span>
            )}
        </div>
    );
}
